import type { ReactNode } from 'react'

import { Bezel } from '../bezel'
import { ICONS } from '../data'
import { useDesk95Theme } from '../theme'

type MyComputerProps = {
    isMobile: boolean
    onOpenProjects: () => void
}

const DRIVES = [
    { key: 'floppy', label: '3½ Floppy (A:)', icon: ICONS.calculator, opens: false },
    { key: 'dos', label: 'Ms-dos_6 (C:)', icon: ICONS.myComputer, opens: false },
    { key: 'cd', label: 'Audio CD (D:)', icon: ICONS.ie, opens: false },
    { key: 'projects', label: 'Projects', icon: ICONS.folder, opens: true },
    { key: 'control', label: 'Control Panel', icon: ICONS.help, opens: false }
]

export const MyComputer = ({ isMobile, onOpenProjects }: MyComputerProps): ReactNode => {
    const palette = useDesk95Theme()

    return (
        <div className='flex size-full flex-col' style={{ background: palette.face }}>
            <Bezel
                variant='sunken'
                face={false}
                className='desk95-scroll m-[3px] min-h-0 flex-1 overflow-y-auto p-[10px]'
                style={{ background: palette.surface }}
            >
                <ul className='grid grid-cols-[repeat(auto-fill,minmax(88px,1fr))] gap-[14px]'>
                    {DRIVES.map(drive => (
                        <li key={drive.key}>
                            <button
                                type='button'
                                className='flex w-full flex-col items-center gap-[5px] p-[4px] text-center'
                                style={{ cursor: 'default', color: palette.surfaceText }}
                                onDoubleClick={() => drive.opens && onOpenProjects()}
                                onClick={() => isMobile && drive.opens && onOpenProjects()}
                            >
                                <img
                                    src={drive.icon}
                                    alt=''
                                    width={32}
                                    height={32}
                                    className='desk95-pixel size-[32px]'
                                    draggable={false}
                                />

                                <span className='text-[11px] leading-[13px]'>
                                    {drive.label}
                                </span>
                            </button>
                        </li>
                    ))}
                </ul>
            </Bezel>

            <div className='flex shrink-0 gap-[3px] px-[3px] pb-[3px]'>
                <Bezel variant='sunken' thin className='flex-1 px-[5px] py-[2px] text-[11px] leading-none'>
                    {DRIVES.length} object(s)
                </Bezel>

                <Bezel variant='sunken' thin className='px-[5px] py-[2px] text-[11px] leading-none'>
                    My Computer
                </Bezel>
            </div>
        </div>
    )
}
